<template>
  <ElRow
    :tag="tag"
    :gutter="gutter"
    :type="type"
    :justify="justify"
    :align="align"
    :class="[spacing ? 'el-row--' + spacing : '', line && 'el-row--line', align === 'baseline' && 'el-row--align-baseline']"
  >
    <slot />
  </ElRow>
</template>

<script>
import { Row as ElRow } from 'element-ui';

export default {
  components: {
    ElRow,
  },
  props: {
    tag: {
      type: String,
    },
    gutter: Number,
    type: String,
    justify: {
      type: String,
    },
    align: {
      type: String,
    },
    spacing: {
      type: String,
    },
    line: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss">
.el-row {
  margin-left: rem(-15px);
  margin-right: rem(-15px);
}

.el-row--flex {
  flex-wrap: wrap;
}

.el-row--line {
  align-items: flex-end;

  @include res(sm-and-down, $--breakpoints-spec) {
    margin-bottom: rem(15px);
  }

  &:not(.destroyed) ~ .el-row--line {
    @include res(lg-and-up, $--breakpoints-spec) {
      .el-form-item__label,
      .floating-label--desktop-up-hidden .el-input__label {
        display: none;
      }
    }

    @include res(sm-and-down, $--breakpoints-spec) {
      padding-top: rem(15px);
      margin-top: rem(15px);
      border-top: 1px solid $--color-gray-2;
    }
  }
}

.el-row--xs {
  margin-left: rem(-1px);
  margin-right: rem(-1px);
  > .el-col {
    padding-left: rem(1px);
    padding-right: rem(1px);
  }
}

.el-row--sm {
  margin-left: rem(-5px);
  margin-right: rem(-5px);
  > .el-col {
    padding-left: rem(5px);
    padding-right: rem(5px);
  }
}

.el-row--md {
  > .el-col {
    &:first-child {
      @include res(md-and-up, $--breakpoints-spec) {
        padding-right: rem(20px);
      }
    }

    &:last-child {
      @include res(md-and-up, $--breakpoints-spec) {
        padding-left: rem(20px);
      }
    }
  }
}

.el-row--lg {
  > .el-col {
    &:first-child {
      @include res(md-and-up, $--breakpoints-spec) {
        padding-right: rem(50px);
      }
    }

    &:last-child {
      @include res(md-and-up, $--breakpoints-spec) {
        padding-left: rem(50px);
      }
    }
  }
}

.el-row--align-baseline {
  align-items: baseline;
}

.el-row--align-center {
  align-items: center;
}
</style>
